// 云后端程序地址
const requestUrl = "/api";
//const requestUrl = "https://aulandin.top:18080";

//const requestUrl = "http://localhost:18080";//本地后端

export const homePage = "https://aulandin.top";

export const avatarUrl = "https://aulandin.top/resource/avatar/";

export const uploadAvatarUrl = requestUrl + "/file/uploadAvatar";

export const deleteAvatarUrl = requestUrl + "/file/deleteImage";

export const getAvatarUrl = requestUrl + "/avatar/getAvatarName";

export const submitChangeAvatarUrl = requestUrl + "/avatar/submitChange";

import request from "superagent";

/**
 * 发送邮件路径
 */
export function getSubmitProductConsultUrl(){
    return requestUrl + "/mail/submitProductConsult";
}

/** 获取ip信息 */
export function getIpInfo(){
  request.get('https://get.geojs.io/v1/ip/geo.json')
  .end((err, res) => {
    if (err) {
      console.error(err);
    } else {
      console.log(res.body);
      sessionStorage.setItem('ipInfo',JSON.stringify(res.body));
    }
  });
}

/**
 * 记录ip信息和操作
 */
export async function recordDetailInfo(operation){
  let ipInfo = sessionStorage.getItem('ipInfo');
  if(ipInfo == null){
    return;
  }
  let resp = await request.post(`${requestUrl}/ipInfo/recordDetailInfo`).send({
    infoMap: JSON.parse(ipInfo),
    visitTime: getCurrentDateTime(),
    operation: operation
  });
  console.log(resp.body);
  // if(resp.data.code == 0){
  //   console.log(resp.data.msg);
  //   return;
  // }
  // return resp.data.data;
}

/**
 * 获取当前时间并格式化成yyyy-MM-dd HH:mm:ss
 */
export function getCurrentDateTime(){
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const day = now.getDate().toString().padStart(2, '0');
  const hours = now.getHours().toString().padStart(2, '0');
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const seconds = now.getSeconds().toString().padStart(2, '0');
  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  return formattedDate;
}

export function getLoginUrl(){
  return requestUrl + "/customer/login";
}

export function getRegisterUrl(){
  return requestUrl + "/customer/register";
}

export function getShopCarUrl(){
  return requestUrl + "/shopCar/getShopCar";
}

export function getAddShopCarUrl(){
  return requestUrl + "/shopCar/addShopCar";
}

export function getDeleteShopCarUrl(){
  return requestUrl + "/shopCar/deleteShopCar";
}

export function getAddOrdersUrl(){
  return requestUrl + "/orders/addOrders";
}

export function getAlipayUrl(){
  return requestUrl + "/alipay/pay";
}

export function getAlipayPhoneUrl(){
  return requestUrl + "/alipay/pay_phone";
}

export function getBuyNowUrl(){
  return requestUrl + "/orders/buyNow";
}

export function buyNow(username,data){
    request.post(`${getBuyNowUrl()}?username=${username}&price=${data.price}`)
    .send(data)
    .end((err,res) => {
      const newWindow = window.open('');
      newWindow.location.href = `${getAlipayUrl()}?ordersId=${res.body.data.id}`;
    });
}

export function getVerifiedCodeUrl(){
  return requestUrl + "/customer/getVerifiedCode";
}

export function getChangePwdVerifiedCodeUrl(){
  return requestUrl + "/customer/getChangePwdVerifiedCode";
}

export function getChangePasswordUrl(){
  return requestUrl + "/customer/changePassword";
}

export function getOrdersRecordTableDataUrl(){
  return requestUrl + "/customer/ordersRecordTableData";
}

export function getDeleteOrdersUrl(){
  return requestUrl + "/orders/deleteOrders";
}

export function getProvinceDataUrl(){
  return requestUrl + "/china/province";
}

export function getBelongDataUrl(){
  return requestUrl + "/china/belong";
}

export function getByUsernameUrl(){
  return requestUrl + "/receiveAddress/getByUsername";
}

export function getAddReceiveAddressUrl(){
  return requestUrl + "/receiveAddress/add";
}

export function quickBuyUrl(){
  return requestUrl + "/orders/quickBuy";
}

export function judgePostionUrl(){
  return requestUrl + "/tencentMap/judgePostion";
}

export function wecharUrl(){
  return requestUrl + "/wechatpay/pay";
}


// WEBPACK FOOTER //
// ./src/request/request.js